import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface RoleSelectProps {
  role: string;
  onRoleChange: (value: string) => void;
  disabled?: boolean;
  allowedRoles?: string[];
}

const DEFAULT_ROLES = ['socio', 'profesor', 'monitor', 'manager', 'recepcionista'];

export const RoleSelect = ({ 
  role, 
  onRoleChange, 
  disabled = false,
  allowedRoles = DEFAULT_ROLES
}: RoleSelectProps) => {
  const getRoleLabel = (r: string) => {
    switch (r) {
      case 'admin': return 'Administrador';
      case 'manager': return 'Manager';
      case 'profesor': return 'Profesor';
      case 'monitor': return 'Monitor';
      case 'recepcionista': return 'Recepcionista';
      default: return 'Socio';
    }
  };

  return (
    <Select value={role} onValueChange={onRoleChange} disabled={disabled}>
      <SelectTrigger className="w-[150px]">
        <SelectValue placeholder="Seleccionar rol" />
      </SelectTrigger>
      <SelectContent>
        {allowedRoles.map((r) => (
          <SelectItem key={r} value={r}>
            {getRoleLabel(r)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
